import image1 from 'images/news-cards/news-1.jpg';
import image2 from 'images/news-cards/news-2.jpg';
import image3 from 'images/news-cards/news-3.jpg';
import image4 from 'images/news-cards/news-4.jpg';
import image5 from 'images/news-cards/news-5.jpg';
import image6 from 'images/news-cards/news-6.jpg';
import image7 from 'images/news-cards/news-7.jpg';
import image8 from 'images/news-cards/news-8.jpg';
import image9 from 'images/news-cards/news-9.jpg';

export const data = [
    {
        img: image1,
        title: 'Betino® has received confirmation from Organic Standard',
        label: 'News',
        date: '31.08.2023',
        readTime: '5 min to read',
        type: 'big',
    },
    {
        img: image2,
        title: 'Agro Conference "Organic agriculture"',
        label: 'Event',
        date: '29.08.2023',
        readTime: '3 min to read',
    },
    {
        img: image3,
        title: 'Promotion "Wuxal for autumn cultivation"',
        label: 'Promo',
        date: '29.08.2023',
        readTime: '3 min to read',
    },
    {
        img: image4,
        title: 'Friendly seedlings under stressful conditions',
        label: 'Article',
        date: '29.08.2023',
        readTime: '3 min to read',
    },
    {
        img: image5,
        title: 'Challenges of the 21st century',
        label: 'research',
        date: '29.08.2023',
        readTime: '3 min to read',
    },
    {
        img: image6,
        title: 'Ferniplant Universal - the universal fertilizer',
        label: 'News',
        date: '29.08.2023',
        readTime: '3 min to read',
    },
    {
        img: image7,
        title: 'Betino - the combination makes the difference!',
        label: 'Article',
        date: '29.08.2023',
        readTime: '3 min to read',
    },
    {
        img: image8,
        title: 'Leaf as a factor influencing the harvest',
        label: 'Research',
        date: '29.08.2023',
        readTime: '3 min to read',
    },
    {
        img: image9,
        title: 'Open jobs!',
        label: 'News',
        date: '29.08.2023',
        readTime: '3 min to read',
    },
];

export const newsSlides = [
    {
        img: image5,
        title: 'Challenges of the 21st century',
        label: 'research',
        date: '29.08.2023',
        readTime: '3 min to read',
    },
    {
        img: image6,
        title: 'Ferniplant Universal - the universal fertilizer',
        label: 'News',
        date: '29.08.2023',
        readTime: '3 min to read',
    },
    {
        img: image7,
        title: 'Betino - the combination makes the difference!',
        label: 'Article',
        date: '29.08.2023',
        readTime: '3 min to read',
    },
    {
        img: image8,
        title: 'Leaf as a factor influencing the harvest',
        label: 'Research',
        date: '29.08.2023',
        readTime: '3 min to read',
    },
    {
        img: image9,
        title: 'Open jobs!',
        label: 'News',
        date: '29.08.2023',
        readTime: '3 min to read',
    },
];

export const homepageNews = [
    {
        img: image6,
        title: 'Ferniplant Universal - the universal fertilizer',
        label: 'News',
        date: '29.08.2023',
        readTime: '3 min to read',
    },
    {
        img: image7,
        title: 'Betino - the combination makes the difference!',
        label: 'Article',
        date: '29.08.2023',
        readTime: '3 min to read',
    },
    {
        img: image8,
        title: 'Leaf as a factor influencing the harvest',
        label: 'Research',
        date: '29.08.2023',
        readTime: '3 min to read',
    },
    {
        img: image9,
        title: 'Open jobs!',
        label: 'News',
        date: '29.08.2023',
        readTime: '3 min to read',
    },
];
